document.addEventListener("DOMContentLoaded", function () {
  new Splide(".video_slider", {
    perPage: 5,
    gap: 17,
    arrows: false,
    drag: false,
    breakpoints: {
      1023: {
        gap: 15,
        arrows: true,
        drag: true,
        perPage: 2,
      },
      767: {
        gap: 10,
        arrows: true,
        drag: true,
        perPage: 2,
        padding: { left: "20px", right: "34px" },
      },
    },
  }).mount();

  new Splide(".review-slider__vf3", {
    perPage: 2,
    gap: 20,
    arrows: true,
    drag: true,
    breakpoints: {
      1023: {
        gap: 15,
        arrows: true,
        drag: true,
        perPage: 2,
      },
      767: {
        gap: 10,
        arrows: true,
        drag: true,
        perPage: 1,
        padding: { left: "20px", right: "62px" },
      },
    },
  }).mount();

  const allSlides = document.querySelectorAll(".video_slider-slide");

  allSlides.forEach((slide) => {
    const video = slide.querySelector("video");
    const btn = slide.querySelector(".video-playbtn");

    // Make sure videos are paused, muted, and controls are hidden initially
    video.pause();
    video.currentTime = 0;
    video.muted = true;
    video.controls = false;

    btn.addEventListener("click", () => {
      // Pause/mute/hide controls on all videos
      allSlides.forEach((s) => {
        const v = s.querySelector("video");
        const b = s.querySelector(".video-playbtn");
        v.pause();
        v.muted = true;
        v.controls = false;
        b.style.display = "flex"; // show all buttons again
      });

      // Play clicked video
      video.muted = false;
      video.controls = true;
      video.play();

      // Hide this play button
      btn.style.display = "none";
    });
  });
});
